export const uiTypes = { // eslint-disable-line
    box: 'box',
    toast: 'toast',
    inline: 'inline',
};
